import styles from './styles.module.scss';

export const Spinner = () => (
  <div className={styles.spinner}>
    <svg
      className={styles.spinnerIcon}
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="24"
        cy="24"
        r="20"
        stroke="#E5E3E3"
        strokeWidth="4"
        strokeLinecap="round"
        strokeDasharray="125.664"
        strokeDashoffset="0"
      />
      <circle
        cx="24"
        cy="24"
        r="20"
        stroke="currentColor"
        strokeWidth="4"
        strokeLinecap="round"
        strokeDasharray="125.664"
        strokeDashoffset="62.832"
        transform="rotate(-90 24 24)"
      />
    </svg>
  </div>
);
